export function createVStack({ Root, }) {
    Root.displayName = 'VStack';
    return Root;
}
